// Validaciones de la sede y la fecha de entrega guardadas en userOrder (localStorage "user-pleizt").

const INACTIVE_VALUES = [0, "0", false, "false", "inactive", "inactivo"];

// Solo descarta la sede si el backend manda el estado (is_active / status).
// Si el campo no viene, no se asume nada: el filtro de fondo va en api-menu-digital.
export const isShopActive = (shop) => {
    if (!shop) return false;
    for (const field of ["is_active", "status"]) {
        const value = shop[field];
        if (value === undefined || value === null) continue;
        if (INACTIVE_VALUES.includes(typeof value === "string" ? value.toLowerCase() : value)) return false;
    }
    return true;
};

// El backend toma la sede de guests.shopData.value, así que se guarda junto al uuid.
export const normalizeShop = (shop) => ({
    ...shop,
    value: shop.uuid ?? shop.value,
    label: shop.name,
});

export const getShopId = (shopData) => shopData?.value || shopData?.uuid || "";

// dateDelivery viene como "YYYY-MM-DD HH:mm"; null significa "lo antes posible".
export const isPastDateDelivery = (dateDelivery) => {
    if (!dateDelivery) return false;
    const [datePart, timePart = "00:00"] = String(dateDelivery).split(" ");
    const [year, month, day] = datePart.split("-").map(Number);
    const [hour, minute] = timePart.split(":").map(Number);
    const deliveryDate = new Date(year, month - 1, day, hour, minute);
    if (isNaN(deliveryDate.getTime())) return true;
    return deliveryDate <= new Date();
};
